<template>
  <div>
    <v-dialog v-model="contractDialog" max-width="1300" scrollable persistent>
      <v-card outlined>
        <v-overlay absolute v-if="isLoading" opacity="1" color="white">
          <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
        </v-overlay>
        <v-card-title class="d-flex justify-space-between align-center primary white--text">
          <div>
            <span v-if="areaObject" style="margin:0 5px;">{{ $t('area.space') }} {{ areaObject.name }}</span>
            <span v-if="getContract && getContract.objectId" style="margin:0 0 0 5px;">{{ $t('contract.title') }} {{ getContract.contractId
            }}</span>
            <span v-if="getContract && getContract.businessName">
              {{ $t('bill.business_name') }} {{ getContract.businessName ? getContract.businessName : '-'}}
            </span>
            <span v-if="getContract && getContract.isSuspend"
              class="warning--text text--lighten-1">({{ $t('suspend.stall_in_suspend')}}{{ getCurrentContractSuspend ? `${$t('to_date')}
              ${dateString(getCurrentContractSuspend.endDate)}` : '' }})</span>
            <span v-if="!areaObject && !getContract" style="margin:0 5px;">-</span>
          </div>
          <v-btn color="white" icon @click="contractDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="margin:0;padding:0;">
          <div class="d-flex sticky-top shadow">
            <div class="tabs-wrapper">
              <v-tabs v-model="tabs" :color="tabs == 'renew_contract' && renewContract ? 'warning' : 'primary'"
                :slider-color="tabs == 'renew_contract' && renewContract ? 'warning' : 'primary'"
                :show-arrows="true">
                <v-tab ripple v-if="!showArea" :href="`#AreaInterest`">{{ $t('area.area_interest') }}
                  <v-badge v-if="areaInterests && areaInterests.length" color="error">
                    <template v-slot:badge>
                      <span>{{ areaInterests.length }}</span>
                    </template>
                  </v-badge>
                </v-tab>
                <v-tab ripple v-if="!showArea" :href="`#AreaBooking`">{{ $t('booking.booking_area') }}
                  <v-badge v-if="bookingItems && bookingItems.length" color="error">
                    <template v-slot:badge>
                      <span>{{ bookingItems.length }}</span>
                    </template>
                  </v-badge>
                </v-tab>
                <v-tab ripple :href="`#RentalContract`">{{ $t('contract.rental_contract') }}
                  <v-badge v-if="getContract" color="error" dot>
                  </v-badge>
                </v-tab>
                <v-tab ripple v-if="renewContract" :href="`#RenewContract`">
                  <v-icon color="warning" class="mr-2">mdi-file-clock-outline</v-icon>{{ $t('customer.waiting_renew_agreement') }}
                  <v-badge color="error" dot> </v-badge>
                </v-tab>
                <v-tab ripple v-if="areaVacancy" :href="`#CustomerInfo`">{{ $t('customer.customer_information') }}
                  <v-badge v-if="getContract" color="error" dot> </v-badge>
                </v-tab>
                <v-tab ripple v-if="areaVacancy" :href="`#SuspendHistory`">{{ $t('suspend.history_suspend_business') }}
                  <v-badge v-if="getCurrentContractSuspend" color="error" dot> </v-badge>
                </v-tab>
                <v-tab ripple v-if="areaVacancy" :href="`#Bill`">
                  {{ $t('bill.bill_list') }}
                  <v-badge
                    v-if="getInvoiceContract && getInvoiceContract.length && getInvoiceContract.filter(i => !i.isPaid && i.isSent).length"
                    color="error">
                    <template v-slot:badge>
                      <span>{{ getInvoiceContract.filter(i => !i.isPaid && i.isSent).length }}</span>
                    </template>
                  </v-badge>
                  <img v-if="getInvoiceContract && getInvoiceContract.find(d => d.invoicePayment)" width="25"
                    :class="`money-sign ${getInvoiceContract && getInvoiceContract.length &&
                    getInvoiceContract.filter(i => !i.isPaid && i.isSent).length ? 'secondary' : ''}`"
                    :src="require(`../assets/images/money-sign-orange.svg`)" />
                </v-tab>
                <v-tab ripple v-if="!showArea" :href="`#MeterDigital`">
                  {{ $t('meter.digital_meter') }}
                  <img width="25"
                    v-if="getMetersElec && areaObject && getMetersElec.find(d => d.isPaymentApprove && d.area.objectId == areaObject.objectId)"
                    :class="`money-sign`"
                    :src="require(`../assets/images/money-sign-orange.svg`)"
                    alt="money-sign-orange" />
                </v-tab>
                <v-tab ripple v-if="areaVacancy" :href="`#AssetList`">{{ $t('asset.asset_list') }}
                  <!-- <v-badge v-if="getContractAssets && getContractAssets.length" color="error" dot>
                    <template v-slot:badge>
                      <span>{{ getContractAssets.length }}</span>
                    </template>
                  </v-badge> -->
                </v-tab>
                <v-tab ripple v-if="areaVacancy && getContract && (getContract.isActive || (getContract.isActive === false && getCheckouts.length > 0))" :href="`#Checkout`">
                  {{ $t('area.checkout_and_decrease_stall') }}
                  <v-badge v-if="getCheckouts && getCheckouts.length" color="error" dot> </v-badge>
                  <img v-if="getCheckouts && getCheckouts.find(d => d.invoicePayment)" width="25" class="money-sign"
                    :src="require(`../assets/images/money-sign-orange.svg`)" />
                </v-tab>
              </v-tabs>
            </div>
            <div
              v-if="showAreaHistoryButton"
              class="area-history-container">
              <v-btn class="area-history-btn" @click="viewAreaHistory()">
                <v-icon>mdi-history</v-icon>
                <span>{{ $t('area.area_history') }}</span>
              </v-btn>
            </div>
          </div>
          <v-tabs-items v-model="tabs">
            <v-tab-item  v-if="!showArea" value="AreaInterest">
              <v-card min-height="600" :loading="isLoading">
                <PermissionValidation :marketId="marketId" rule="enableViewAreaInterests">
                  <v-card-text>
                    <div class="flex items-center justify-between my-3">
                      <h3>{{ $t('area.area_interest') }}</h3>
                      <v-btn @click="addAreaInterest()" color="info">
                        <v-icon left>mdi-plus</v-icon>
                        {{ $t('project.add_interested_person') }}
                      </v-btn>
                    </div>
                    <div v-if="areaInterests && areaInterests.length">
                      <div v-for="(areaInterest) in areaInterests" :key="areaInterest.objectId"
                        class="flex booking-box sp justify-space-between align-center"
                        @click="clickAreaInterest(areaInterest)">
                        <div>
                          <div>{{ $t('market.customer_name_and_company_not_space') }} : {{ areaInterest.getCustomerName }}</div>
                          <div>{{ $t('customer.customer_type') }} : {{ areaInterest.customerTypeString }}</div>
                          <div>{{ $t('contract.contract_duration') }} : {{ areaInterest.contractStartDateString }} - {{
                            areaInterest.contractEndDateString }}</div>
                          <div>{{ $t('area.space') }} : {{ areaInterest.areasString }}</div>
                          <div>{{ $t('product.product_in_sell') }} : {{ areaInterest.productNames.join(',') || '-' }}</div>
                        </div>
                        <div class="float-right">
                          <span :class="areaInterest.statusColor + ' px-3 py-1 rounded-full '">{{
                            areaInterest.getStatusString }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="flex align-center justify-center p-20 text-lg">{{ $t('booking.no_booking_data') }}</div>
                  </v-card-text>
                </PermissionValidation>
              </v-card>
            </v-tab-item>
            <v-tab-item  v-if="!showArea" value="AreaBooking">
              <v-card min-height="600" :loading="isLoading">
                <v-card-text>
                  <div class="flex items-center justify-between my-3">
                    <h3>{{ $t('booking.booking_area') }}</h3>
                    <v-btn color="info" @click="clickBooking('daily')">
                      {{ $t('booking.add_booking') }}
                    </v-btn>
                  </div>

                  <div v-if="bookingItems && bookingItems.length">
                    <div v-for="(booking, iBooking) in  bookingItems " :key="iBooking"
                      class="flex booking-box sp justify-space-between align-center"
                      @click="clickBooking('booking', booking)">
                      <div class="flex align-center">
                        <div class="img-box">
                          <img v-if="booking.type == 'daily'" src="../assets/images/day-icon.png" alt="day-icon" />
                          <img v-if="booking.type == 'monthly'" src="../assets/images/month-icon.png" alt="month-icon" />
                        </div>
                        <div class="text-box">
                          <div>{{ fullName(booking.customer) }}</div>
                          <div>{{ booking.type == 'daily' ? $t('booking.date_booking') : $t('contract.start_doing_contract_date') }} {{ dayByArea(booking) }}
                          </div>
                          <div>
                            <v-chip 
                              style="margin-right:5px;"
                              class="chip-text"
                              :class="booking.type == 'daily' ? 'booking-daily' : 'booking-monthly' "
                            >
                              {{booking.documentId || '-' }}
                            </v-chip>
                            <template v-for="currency in $helper.currencyOptions">
                              <v-chip
                                v-if="sumField(booking.invoices, 'totalUnpaidValue', null, currency.value) == 0 && sumField(booking.invoices, 'totalPaidValue', null, currency.value) > 0"
                                :key="'paid-' + currency.value"
                                color="rgb(209,242,225)" class="green--text mb-1" style="margin-right:5px;">{{ $t('payment.all_paid') }}
                                {{ sumField(booking.invoices, 'totalPaidValue', null, currency.value) | currency }} {{ $helper.currencySign(currency.value) }}</v-chip>
                              <v-chip v-else-if="sumField(booking.invoices, 'totalPaidValue', null, currency.value) > 0" 
                                :key="'partial-' + currency.value"
                                color="rgb(209,242,225)"
                                class="green--text mb-1" style="margin-right:5px;">{{ $t('payment.paid_already') }} {{
                                  sumField(booking.invoices,
                                    'totalPaidValue', null, currency.value) | currency }} {{ $helper.currencySign(currency.value) }} </v-chip>
                              <v-chip v-if="sumField(booking.invoices, 'totalUnpaidValue', null, currency.value) > 0" 
                                :key="'unpaid-' + currency.value"
                                color="rgb(248,218,218)"
                                class="red--text mb-1" style="margin-right:5px;">{{ $t('payment.pending') }} {{ sumField(booking.invoices,
                                  'totalUnpaidValue', null, currency.value) | currency }} {{ $helper.currencySign(currency.value) }}</v-chip>
                            </template>
                            <v-chip v-if="booking.isPaymentApprove" color="#ff8a3b" class="mr-1 px-0 py-0">
                              <img width="32" :src="require(`../assets/images/money-sign.svg`)" />
                            </v-chip>
                          </div>
                        </div>
                      </div>

                      <div v-if="getCheckInOutByArea(booking)" class="float-right">
                        <template v-if="booking.status != 'cancelled'">
                          <v-chip color="success" class="me-2" v-if="booking.contract">{{ $t('contract.already_do_contract') }}</v-chip>
                          <v-chip color="info" v-if="getCheckInOutByArea(booking).isCheckIn">{{ $t('area.already_enter_stall') }}</v-chip>
                          <v-chip color="warning"
                            v-if="getCheckInOutByArea(booking).isCheckInToDay">{{ $t('area.enter_stall_today') }}</v-chip>
                          <v-chip color="error" v-if="getCheckInOutByArea(booking).isExpire">{{ $t('area.overdue') }}</v-chip>
                        </template>
                        <v-chip color="error" v-if="booking.status == 'cancelled'">{{ $t('cancel') }}</v-chip>
                        <!-- <div>Check-In : {{ getCheckInOutByArea(booking).checkedInDate ? dateFormat(getCheckInOutByArea(booking).checkedInDate.iso) : '-'}}</div> -->
                        <!-- <div>Check-Out : {{ getCheckInOutByArea(booking).checkedOutDate ? dateFormat(getCheckInOutByArea(booking).checkedOutDate.iso) : '-'}}</div> -->
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex align-center justify-center p-20 text-lg">{{ $t('booking.no_booking_data') }}</div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item  value="RentalContract">
              <v-card flat v-if="areaVacancy">
                <v-card-text class="py-5" v-if="getContract">
                  <div class="flex items-center py-5 align-middle justify-space-between">
                    <h2>
                      <small class="mb-2 d-block">{{ $t('contract.contract_id') }}</small>
                      {{
                        getContract
                        ? getContract.contractId
                          ? getContract.contractId
                          : "-"
                        : "-"
                      }}
                    </h2>
                    <div class="text-right">
                      <v-chip class="chip-text" :class="getContract.statusClass.class" :color="getContract.statusClass.color">
                        <v-icon left x-small> mdi-circle </v-icon> 
                        {{ getContract.statusClass.text }}
                      </v-chip>
                      <!-- <div class="flex justify-end">
                        <span rounded elevation="0" class="chip-text" :class="getContract.status.class + ' py-1 px-3 rounded-3xl'">
                          {{ getContract.status.text }}
                        </span>
                      </div> -->
                      <div class="my-1">
                        {{ $t('contract.contract_created_at') }}
                        {{ dateString(getContract.createdAt) }}
                      </div>
                    </div>
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <div>{{ $t('contract.business_name') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">{{ getContract.businessName || "-" }}
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div>{{ $t('market.rent_type') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        {{
                          getContract.stallType
                          ? getContract.stallType == "temporary"
                            ? $t('contact.stall_type.temporary')
                            : $t('contact.stall_type.regularly')
                          : "-"
                        }}
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div>{{ $t('contract.start_date') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.startDate">{{ dateString(getContract.startDate.iso) }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div>{{ $t('contract.end_date') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.endDate">{{ dateString(getContract.endDate.iso) || "-" }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <span>{{ $t('contract.contract_period') }} {{ dayMonthYearText() }}</span>
                      <div class="px-3 py-3 mx-3 rounded grey lighten-4">{{ diffDays() || 0 }} {{ $t('day') }}</div>
                    </v-col>
                    <v-col cols="12">
                      <h3>Credit Term</h3>
                    </v-col>
                    <v-col cols="12">
                      <div>
                        {{ $t('market.due_date_after_bill') }}
                        <span class="px-3 py-3 rounded grey lighten-4 show-contract">{{ $t('period') }} {{ getContract.creditTerm ||
                          '-' }} {{ $t('day') }}</span>
                        <span v-if="getContract.creditTerm"
                          class="px-3 py-3 mx-3 rounded grey lighten-4 show-contract">{{ $t('market.example_document_issue_date') }}
                          {{ $moment().format('DD/MM/YYYY') }}</span>
                        <span v-if="getContract.creditTerm"
                          class="px-3 py-3 rounded grey lighten-4 show-contract">{{ $t('market.example_document_due_date') }} {{
                            $moment().add(
                              getContract.creditTerm, 'days').format('DD/MM/YYYY') }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <h3>{{ $t('contract.contractor_information') }}</h3>
                    </v-col>
                    <v-col cols="12">
                      <div>{{ $t('customer.company_name_and_customer_name') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.billingData">{{ getContract.billingData.name || "-" }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>

                    <v-col cols="6">
                      <div>{{ $t('address.company_branch') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.billingData">{{ getContract.billingData.branchName || "-"
                        }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>
                    <v-col cols="6" v-if="getContract.billingData">
                      <div>{{ $t('tax.tax_id_number_another_form') }}
                        <WarningCitizenIdIcon v-if="getContract.billingData" v-model="getContract.billingData.taxId"
                          :isVat="getContract.customer && getContract.customer.type == 'company' ? true : false"
                          :isExport="false" />
                      </div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.billingData">{{ getContract.billingData.taxId || "-" }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div>{{ $t('account.address') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.billingData">{{ getContract.billingData.address || "-" }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div>{{ $t('account.phone_number') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.billingData">{{ getContract.billingData.tel || "-" }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div>{{ $t('account.email') }}</div>
                      <div class="px-3 py-3 rounded grey lighten-4 show-contract">
                        <template v-if="getContract.billingData">{{ getContract.billingData.email || "-" }}</template>
                        <template v-else>-</template>
                      </div>
                    </v-col>

                    <v-col cols="12">
                      <div class="d-flex justify-space-between">
                        <h3>{{ $t('contract.rent_list_in_contract') }}</h3>
                        <v-btn elevation="0" color="info" small @click="addAreaProduct()"
                          :disabled="!getContract.isActive">
                          <v-icon left>mdi-plus-box</v-icon>{{ $t('area.add_area_stall') }}
                        </v-btn>
                      </div>
                      <div class="py-5">
                        <areas-list :areas="getContract.areas" :list="true" v-model="showDialog" @onDelSave="delSave"
                          @onChangeAreaProduct="getAreaProductDialog"></areas-list>
                        <v-card v-if="!getContract.areas || getContract.areas.length < 1
                          " class="mt-5 grey lighten-4" flat>
                          <v-card-text>{{ $t('contract.no_stall_in_this_contract') }}</v-card-text>
                        </v-card>
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="getContract.startMeterData">
                      <div class="d-flex justify-space-between mb-3">
                        <h3>{{ $t('meter.first_meter') }}</h3>
                      </div>
                      <div class="ps-4" v-if="getMetersWater && getMetersWater.length > 0">
                        <p>
                          <b>{{ $t('meter.water_meter') }}</b>
                        </p>
                        <v-row>
                          <template v-for="  meter   in   getMetersWater  ">
                            <v-col cols="4" :key="`water_${meter.objectId}`" class="d-flex align-center ps-6">{{
                              meter.area.name }}</v-col>
                            <v-col cols="4" :key="`water2_${meter.objectId}`" class="d-flex align-center ps-6">
                              <template v-if="meter.name">{{ meter.name }}</template>
                              <template v-else-if="meter.isMain">{{ $t('main') }}</template>
                              <template v-else>{{ $t('additional') }}</template>
                            </v-col>
                            <v-col cols="4" :key="`water3_${meter.objectId}`">
                              <div class="px-3 py-3 rounded show-contract water">{{
                                getContract.startMeterData[meter.objectId] ?
                                getContract.startMeterData[meter.objectId].unit : 0 }}</div>
                            </v-col>
                          </template>
                        </v-row>
                      </div>
                      <br />
                      <div class="ps-4" v-if="getMetersElec && getMetersElec.length > 0">
                        <p>
                          <b>{{ $t('meter.electricity_meter') }}</b>
                        </p>
                        <v-row>
                          <template v-for="  meter   in   getMetersElec  ">
                            <v-col cols="4" :key="`elec_${meter.objectId}`" class="d-flex align-center ps-6">{{
                              meter.area.name }}</v-col>
                            <v-col cols="4" :key="`elec2_${meter.objectId}`" class="d-flex align-center ps-6">
                              <template v-if="meter.name">{{ meter.name }}</template>
                              <template v-else-if="meter.isMain">{{ $t('main') }}</template>
                              <template v-else>{{ $t('additional') }}</template>
                            </v-col>
                            <v-col cols="4" :key="`elec3_${meter.objectId}`">
                              <div class="px-3 py-3 rounded show-contract elec">{{
                                getContract.startMeterData[meter.objectId] ?
                                getContract.startMeterData[meter.objectId].unit : 0 }}</div>
                            </v-col>
                          </template>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="flex justify-between">
                        <h3>{{ $t('customer.document_set_list') }}</h3>
                        <v-btn color="info" small elevation="0" @click="contractDocumentDialog($event, false)"
                          :disabled="!getContract.isActive">
                          <v-icon left>mdi-plus-box</v-icon>{{ $t('contract.add_contract_document') }}
                        </v-btn>
                      </div>
                      <div class="py-5">
                        <card-contract-document v-for="(  doc, index  ) of   getContractDocuments  " :key="`doc_${index}`"
                          :indexNumber="`${index + 1}`" :object="doc" @onView="contractDocumentDialog(doc, true, true)"
                          @onUpdated="contractDocumentDialog(doc, true)"
                          @onRemove="contractDocumentRemoveDialog(doc)"></card-contract-document>

                        <card-contract-document v-if="getContractDocuments.length < 1"
                          :isNull="true"></card-contract-document>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="flex">
                        <v-icon right>mdi-swap-horizontal</v-icon>
                        <h3>{{ $t('contract.contract_history') }}</h3>
                      </div>
                      <card-contract-log :contractLog="getContractLog"></card-contract-log>
                    </v-col>
                  </v-row>

                  <v-btn color="primary" elevation="0" @click="updateContract(); getProduct();"
                    :disabled="!getContract.isActive">
                    <v-icon left>mdi-file-edit</v-icon>{{ $t('contract.edit_contract') }}
                  </v-btn>
                  <template v-if="getContract.status && getContract.status.code !== '001'"></template>
                </v-card-text>
              </v-card>
              <div v-else style="min-height:600px" class="flex align-center justify-center pb-20">
                <v-btn elevation="0" color="success" @click="getCustomers(areaObject)"
                  :disabled="!areaObject || areaObject.contract ? true : false || areaObject.areaBooking ? true : false">
                  <v-icon left>mdi-plus</v-icon>{{ $t('customer.add_customer') }}
                </v-btn>
              </div>
            </v-tab-item>
            <v-tab-item  v-if="renewContract" value="RenewContract">
              <RenewContractDetail @onCancelRenewContract="loadContract()" />
            </v-tab-item>
            <v-tab-item  v-if="areaVacancy" value="CustomerInfo">
              <v-card flat>
                <v-card-text>
                  <ProfileDetail :contractId="getContractId" :contract="getContract"
                    @reloadContract="$emit('reloadContract')" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item  v-if="areaVacancy" value="SuspendHistory">
              <ContractSuspend :contractId="getContractId" :contract="getContract" @reloadContract="onEditContract()" />
            </v-tab-item>
            <v-tab-item  v-if="areaVacancy" value="Bill">
              <ContractBills :isDialog="contractDialog" :contractId="getContractId" :contract="getContract"
                @reloadContract="$emit('reloadContract')" />
            </v-tab-item>
            <v-tab-item  v-if="!showArea" value="MeterDigital">
              <MeterDigitalList 
              v-if="contractDialog"
              :marketId="marketId" :projectId="projectId"
              :area="areaObject ? areaObject : null"
              :contract="getContract ? getContract : null"
              :booking="areaObject && areaObject.areaBooking ? areaObject.areaBooking : null"
              @reloadContract="$emit('reloadContract')" />
            </v-tab-item>
            <v-tab-item  v-if="areaVacancy" value="AssetList">
              <check-list :contractId="getContractId" v-if="getContractId"></check-list>
            </v-tab-item>
            <v-tab-item  v-if="areaVacancy && getContract && (getContract.isActive || (getContract.isActive === false && getCheckouts.length > 0))" value="Checkout">
              <checkout :marketId="marketId" :projectId="projectId" :isContract="value" :check="value"
                @onCloseContract="onCloseContract" @onReduce="onReduceContract" @onCreateSuccess="onCreateCheckout"></checkout>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <billing-select v-if="getProjectId" v-model="isBillingSelect"
      @onSaveSuccess="loadInvoice(contractId)"></billing-select>
    <confirm-dialog-component v-model="isConfirmContractDocumentRemove" @onOk="contractDocumentRemove"
      :title="$t('validate.you_want_to_delete_this_document_set')" type="error"></confirm-dialog-component>
    <FormAreaProducts v-model="addAreaDialog" @onSave="saveArea"></FormAreaProducts>
    <FormContract v-model="updateContractDialog" :obj="obj" event="edit" @addProduct="$emit('addProduct')"
      @onUpdated="onEditContract()"></FormContract>
    <v-snackbar v-model="removeLoading" color="warning">{{ $t('deleting') }}...</v-snackbar>
    <form-area-products v-model="isAreaProduct" :obj="areaProductObj" :isChangeArea="isChangeArea"
      @onSaveEdit="saveProduct" @onSave="saveProduct"></form-area-products>
    <contract-document v-model="isContractDocument" :projectId="projectId" :marketId="marketId"
      :contract-id="getContractId || null" :isUpdate="isContractDocumentUpdate" :object-id="isContractDocumentId"
      :isDisable="isContractDocumentDisable"></contract-document>
    <BookingDialog v-model="bookingDialog" :marketId="marketId" :projectId="projectId"
      :areaId="areaObject ? areaObject.objectId : null" :type="bookingType" :booking="booking"
      @createBookingSuccess="createBookingSuccess" :isMainLoading="isLoadBooking" :startDateReq="startDateReq"
      :endDateReq="endDateReq" />
    <select-customer v-model="selectCustomerDialog" @select="createContractDialog"></select-customer>
    <form-contract event="create" v-model="addContractDialog" :areaObject="areaObject" :customer="contractCustomer"
      @onCreateSuccess="createContractSuccess" @areaProduct="getAreaProductDialog"></form-contract>
    <interest-dialog v-if="isInterestDialog" v-model="isInterestDialog"
      :objectId="tempInterest ? tempInterest.objectId : null" :isCreate="tempInterest ? false : true"
      :isUpdate="tempInterest ? true : false" :areaIds="areaObject ? [areaObject.objectId] : null"
      @onSuccess="onSuccessInterest" @onUpdate="reloadAreaInterest()"
      @onCreate="reloadAreaInterest(); isInterestDialog = false;" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Contract } from "../classes/Contract.class";
import FormContract from "./FormContract.vue";
import AreasList from "./AreasList.vue";
import ProfileDetail from "./ProfileDetail.vue";
import ConfirmDialog from "./ConfirmDialog.vue";
import FormAreaProducts from "./FormAreaProducts.vue";
import InvoiceContract from "./InvoiceContract.vue";
import CardContractDocument from "./CardContractDocument.vue";
import CardContractLog from "./CardContractLog.vue";
import ContractDocument from "./ContractDocument.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import BillingSelect from "./BillingSelect.vue";
import Checkout from "./Checkout.vue";
import CheckList from "./CheckList.vue";
import BookingDialog from "./BookingDialog.vue";
import SelectCustomer from "./SelectCustomer.vue";
import ContractSuspend from "./ContractSuspend.vue";
import ContractBills from "./ContractBills.vue";
import RenewContractDetail from "./RenewContractDetail.vue";
import InterestDialog from "./InterestDialog.vue";
import PermissionValidation from "./PermissionValidation.component.vue"
import WarningCitizenIdIcon from "./WarningCitizenIdIcon";
import MeterDigitalList from "./MeterDigitalList.vue";
export default {
  components: {
    // UpdateContract,
    AreasList,
    FormContract,
    ProfileDetail,
    ConfirmDialog,
    FormAreaProducts,
    InvoiceContract,
    CardContractDocument,
    CardContractLog,
    ContractDocument,
    ConfirmDialogComponent,
    BillingSelect,
    Checkout,
    CheckList,
    BookingDialog,
    SelectCustomer,
    ContractSuspend,
    ContractBills,
    RenewContractDetail,
    InterestDialog,
    PermissionValidation,
    WarningCitizenIdIcon,
    MeterDigitalList,
  },
  mounted(){

  },
  data() {
    return {
      isConfirmContractDocumentRemove: false,
      isLoading: false,
      isLoadBooking: false,
      dialog: false,
      updateContractDialog: false,
      obj: {},
      addAreaDialog: false,
      showDialog: false,
      removeLoading: false,
      tabs: 'rental_contract', // Changed from numeric index to string value
      isView: false,
      isAreaProduct: false,
      areaProductObj: {},
      onFirst: true,
      isChangeArea: false,
      invoiceId: "",
      isInvoiceDialog: false,
      isContractDocument: false,
      isContractDocumentUpdate: false,
      isContractDocumentId: "",
      isContractDocumentDisable: false,
      isBillingSelect: false,
      isInvoiceLoading: false,
      isContractLogLoading: false,
      bookingDialog: false,
      bookingType: "",
      booking: null,
      selectCustomerDialog: false,
      contractCustomer: {},
      addContractDialog: false,
      isLoadContractTab: false,
      isInterestDialog: false,
      tempInterest: null,
    };
  },
  computed: {
    ...mapGetters({
      getContract: "contract/getContract",
      getContractLog: "contractLog/getContractLog",
      getContractId: "contract/getContractId",
      getAreas: "markets/getAreas",
      getProjectId: "markets/getProjectId",
      getInvoiceContract: "invoice/getInvoiceContract",
      getContractDocuments: "contractDocument/getContractDocuments",
      getMetersWater: "meter/getMetersWater",
      getMetersElec: "meter/getMetersElec",
      getBookings: "booking/getBookings",
      getCurrentContractSuspend: "contractSuspend/getCurrentContractSuspend",
      getCheckouts: "contractCheckout/checkouts",
      areaInterests: "areaInterest/areaInterests",
      getContractAssets: "contractAsset/getContractAssets",
    }),
    areaVacancy() {
      let show = false;
      if (
        (this.areaObject && this.areaObject.contract) ||
        (this.getContract && this.getContract.objectId)
      ) {
        show = true;
      }
      return show;
    },
    bookingItems() {
      let bookings = [];
      if (this.getBookings && this.getBookings.length) {
        // bookings = this.getBookings;
        for (let getBooking of this.getBookings) {
          if (getBooking.areaBookings)
            getBooking.areaBooking = getBooking.areaBookings.find(
              areaBooking =>
                this.areaObject &&
                areaBooking.area &&
                areaBooking.area.objectId == this.areaObject.objectId
            );
          bookings.push(getBooking);
        }
        if (bookings && bookings.length)
          bookings.sort(function (a, b) {
            return (
              new Date(
                a.areaBooking && a.areaBooking.startDate
                  ? a.areaBooking.startDate.iso
                  : ""
              ) -
              new Date(
                b.areaBooking && b.areaBooking.startDate
                  ? b.areaBooking.startDate.iso
                  : ""
              )
            );
          });
      }
      return bookings;
    },
    contractDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    renewContract() {
      let renewContract
      if (this.getContract && this.getContract.renewEffectiveDate && this.getContract.renewEffectiveContract) renewContract = this.getContract.renewEffectiveContract
      return renewContract
    }
  },
  watch: {
    contractDialog(value) {
      if (this.value) {
        this.isLoadContractTab = false;
        this.loadContract(null, this.initTab);
      } else {
        this.setCurrentArea(null)
      }
    },
    bookingDialog(value) {
      if (!value) {
        if (
          this.booking &&
          this.booking.type == "monthly" &&
          this.booking.status == "success" &&
          this.getContract
        ) {
          this.tabs = 'AreaBooking';
        }
      }
    },
    tabs: {
      handler(value) {
        if (!this.isLoadContractTab) {
          if (this.showArea && value == 'AreaInterest') this.loadContractTab();
          else if (!this.showArea && value == 'RentalContract') this.loadContractTab();
        }
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    value: Boolean,
    showArea: Boolean,
    areaObject: Object,
    projectId: String,
    marketId: String,
    contractId: String,
    startDateReq: Date,
    endDateReq: Date,
    initTab: String,
    showAreaHistoryButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations({
      setCurrentArea: "area/setCurrentArea"
    }),
    contractDocumentRemoveDialog(item) {
      this.isConfirmContractDocumentRemove = true;
      this.isContractDocumentId = item.objectId;
    },
    onReduceContract() {
      this.$emit("reloadContract");
    },
    onCloseContract() {
      this.contractDialog = false;
      this.$emit("reloadContract");
    },
    async contractDocumentRemove() {
      await this.$store.dispatch("contractDocument/removeContractDocument", {
        id: this.isContractDocumentId
      });
      if (this.contractId) this.loadContractDocuments(this.contractId);
    },
    contractDocumentDialog(e, isUpdate = false, isDisable = false) {
      this.isContractDocumentUpdate = isUpdate || false;
      this.isContractDocumentDisable = isDisable || false;
      if (isUpdate) {
        this.isContractDocumentId = e.objectId;
      }
      this.isContractDocument = true;
    },
    onEditContract() {
      this.loadContract(this.contractId);
      this.$emit("reloadContract");
      this.$eventBus.$emit("updateAreaPlan");
    },
    async loadInvoice(id) {
      this.isInvoiceLoading = true;
      if (id)
        await this.$store.dispatch("invoice/getInvoicesByContract", {
          contractId: id,
          marketId: this.marketId,
          projectId: this.projectId
        });
      this.isInvoiceLoading = false;
    },
    getAreaProductDialog(obj) {
      this.isChangeArea = true;
      this.isAreaProduct = true;
      this.areaProductObj = obj;
    },
    async saveProduct(val) {
      this.isAreaProduct = false;
      await this.$store.dispatch("area/updateAreaProducts", {
        id: val.area.objectId,
        productIds: val.products.map(i => i.objectId)
      });
      this.loadContract(this.contractId);
      this.$emit("reloadContract");
      this.$eventBus.$emit("updateAreaPlan");
    },
    onChangeAreaProduct(item) {
      this.$emit("areaProduct", item);
    },
    async delSave(value) {
      try {
        this.removeLoading = true;
        const data = {
          id: this.getContract.objectId,
          areaId: value.objectId
        };
        await this.$store.dispatch("contract/removeContractArea", data);
        this.$emit("reloadContract");
        this.$eventBus.$emit("updateAreaPlan");
        this.showDialog = false;
        this.removeLoading = false;
      } catch (err) { }
    },
    addAreaProduct() {
      this.isChangeArea = false;
      this.addAreaDialog = true;
      this.getProduct();
    },
    async saveArea(value) {
      const input = {
        id: this.getContract.objectId,
        area: value
      };
      this.addAreaDialog = false;
      const add = await this.$store.dispatch(
        "contract/addContractAreas",
        input
      );
      this.$emit("reloadContract");
      this.$eventBus.$emit("updateAreaPlan");
      this.updateContractDialog = false;
    },
    async getProduct() {
      await this.$store.dispatch("product/getProducts", {
        projectId: this.projectId
          ? this.projectId
          : this.$store.getters["markets/getProjectId"]
      });
    },
    updateContract() {
      this.obj = this.getContract;
      this.updateContractDialog = true;
    },
    async loadContract(contractIdIn, initTab) {
      try {
        let contractId = contractIdIn ? contractIdIn : this.contractId;
        this.isLoading = true;

        if (contractId) {
          await Promise.all([
            this.$store.dispatch("contract/getContract", {
              id: contractId
            }),
            this.$store.dispatch("contractCheckout/getContractCheckoutsByContract", {
              contractId: contractId
            }),
            this.loadInvoice(contractId),
            this.loadContractDocuments(contractId)
          ])
        }
        else this.$store.commit("contract/setContract", null);
        await Promise.all([
          this.loadNoContract(),
          this.loadAreaInterest(),
          this.showArea ? this.loadContractTab() : null
        ])

        if(initTab){
          this.tabs = initTab;
        } else if (this.getContract) {
          if (this.getCurrentContractSuspend) {
            if (this.getBookings?.length) {
              this.tabs = 'AreaBooking';
            } else {
              this.tabs = 'SuspendHistory';
            }
          } else {
            this.tabs = 'RentalContract';
          }
        } else if (this.getBookings?.length) {
          this.tabs = 'AreaBooking';
        } else if (this.areaInterests?.length) {
          this.tabs = 'AreaInterest';
        }
        this.isLoading = false;
      } catch (err) {
        console.log("~ err", err);
        this.isLoading = false;
      }
    },
    async loadNoContract() {
      this.isLoading = true;
      await this.loadBooking();
      await this.loadMeterByArea();
      this.isLoading = false;
    },
    async loadContractTab() {
      if (this.getContract && this.getContract.customer) {
        try {
          this.isLoadContractTab = true;
          await this.loadMeter();
          await this.loadContractHistory(this.getContractId);
        } catch (error) {
          if (error?.response?.data?.error) {
            this.$toast.show({
              content: error.response.data.error,
              color: "error"
            });
          } else {
            this.$toast.show({
              content: error.message,
              color: "error"
            });
          }
        }
      }
    },
    async loadContractDocuments(contractId) {
      if (contractId)
        await this.$store.dispatch("contractDocument/getContractDocuments", {
          contractId: contractId
        });
    },
    async loadContractHistory(id) {
      if (id)
        await this.$store.dispatch("contractLog/getContractLog", {
          contractId: id
        });
    },
    async loadBooking() {
      if (this.areaObject && this.areaObject.objectId)
        await this.$store.dispatch(
          "booking/getBookingByArea",
          this.areaObject.objectId
        );
    },
    async loadMeter() {
      await this.$store.dispatch("meter/getMeterByAreas", {
        areaIds: this.getContract.areas.map(d => d.objectId)
      });
    },
    async loadMeterByArea() {
      if (this.areaObject && this.areaObject.objectId)
      await this.$store.dispatch("meter/getMeterByArea", {
        areaId: this.areaObject.objectId
      });
    },
    async loadAreaInterest() {
      if (this.areaObject && this.areaObject.objectId)
        await this.$store.dispatch("areaInterest/getAreaInterestByArea", {
          areaId: this.areaObject.objectId
        });

        await this.$store.dispatch("area/getAreaBookingSummaryByMarket", {
            marketId: this.marketId
        });
    },
    dateString(date) {
      let text = "";
      if (date && date.iso) {
        text = this.$moment(date.iso).format("DD MMMM YYYY");
      } else if (date) {
        text = this.$moment(date).format("DD MMMM YYYY");
      }
      return text;
    },
    clickBooking(bookingType = "", booking) {
      this.booking = null;
      if (bookingType == "booking") this.booking = booking;
      this.bookingType = bookingType;
      this.bookingDialog = true;
    },
    dayByArea(booking) {
      let day = "";
      if (booking.areaBooking) {
        day = `${this.$moment(booking.areaBooking.startDate.iso).format(
          booking.type == "daily" ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"
        )} ${this.$t('to')} ${this.$moment(booking.areaBooking.endDate.iso).format(
          booking.type == "daily" ? "DD/MM/YYYYY HH:mm" : "DD/MM/YYYY"
        )}`;
      }
      return day;
    },
    getCheckInOutByArea(booking) {
      let areaBooking, currentAreaBooking;
      let res;
      areaBooking = booking.areaBookings.find(
        areaBooking =>
          areaBooking.area &&
          this.areaObject &&
          areaBooking.area.objectId == this.areaObject.objectId
      );
      currentAreaBooking = booking.areaBookings.find(
        areaBooking =>
          areaBooking.area &&
          this.areaObject &&
          areaBooking.area.objectId == this.areaObject.objectId &&
          areaBooking.checkedInDate &&
          !areaBooking.checkedOutDate
      );
      if (areaBooking) {
        res = {
          checkedInDate: areaBooking.checkedInDate,
          checkedOutDate: areaBooking.checkedOutDate,
          startDate: areaBooking.startDate,
          endDate: areaBooking.endDate,
          isCheckIn: currentAreaBooking ? currentAreaBooking.checkedInDate && !currentAreaBooking.checkedOutDate : areaBooking.checkedInDate && !areaBooking.checkedOutDate,
          isCheckInToDay:
            !areaBooking.checkedInDate &&
            this.$moment(areaBooking.startDate.iso).isSameOrBefore(
              this.$moment()
            ) &&
            this.$moment(areaBooking.endDate.iso).isSameOrAfter(this.$moment()),
          isExpire:
            !areaBooking.checkedInDate &&
            this.$moment(areaBooking.endDate.iso).isBefore(this.$moment())
        };
      }
      return res;
    },
    async createBookingSuccess(booking) {
      if (booking) {
        this.booking = booking;
      }
      if (this.booking && this.booking.objectId) {
        this.isLoadBooking = true;
        this.booking = await this.$store.dispatch(
          "booking/getBooking",
          this.booking.objectId
        );
        this.isLoadBooking = false;
      }
      if (
        this.booking &&
        this.booking.areaBookings &&
        this.booking.areaBookings.length &&
        this.booking.areaBookings[0] &&
        (this.booking.areaBookings[0].area.contract ||
          this.booking.areaBookings[0].area.areaBooking)
      ) {
        if (
          this.booking.areaBookings[0].area.contract &&
          this.booking.areaBookings.find(d => d.area.objectId == this.areaObject.objectId)
        ) {
          this.loadContract(
            this.booking.areaBookings[0].area.contract.objectId
          );
        }
      }
      this.loadNoContract();
      this.$emit("reloadContract", this.booking);

    },
    getCustomers() {
      this.selectCustomerDialog = true;
    },
    async createContractDialog(value) {
      this.isLoading = true;
      await this.$store.dispatch("customer/getCustomer", {
        id: value.objectId
      });
      this.isLoading = false;
      this.addContractDialog = true;
      this.selectCustomerDialog = false;
    },
    createContractSuccess(contract) {
      this.loadContract(contract.objectId)
      this.$emit("reloadContract");
    },
    onCreateCheckout(checkout) {
      this.loadContract(checkout.contract.objectId, "Checkout")
      this.$emit("reloadContract");
    },
    dateFormat(date, outFormat = "DD-MMM-YYYY HH:mm") {
      let res = "";
      if (date) {
        res = this.$moment(date).format(outFormat);
      }
      return res;
    },
    sumField(data, key, key2, currencyCode) {
      if (!data || !data.length) return 0;
      const groupedData = data.reduce((acc, item) => {
        const code = item.currencyCode || 'THB';
        if (!acc[code]) acc[code] = [];
        acc[code].push(item);
        return acc;
      }, {});

      if (currencyCode) {
        const items = groupedData[currencyCode] || [];
        if (key2) {
          return items.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
        }
        return items.reduce((a, b) => a + (b[key] || 0), 0);
      }
      if (key2) {
        return data.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
      }
      return data.reduce((a, b) => a + (b[key] || 0), 0);
    },
    fullName(customer) {
      let res = "";
      if (customer.type == "personal") {
        res = `${customer.firstName} ${customer.lastName}`;
      } else if (customer.type == "company") {
        res = `${customer.companyName}`;
      }
      return res;
    },
    diffDays() {
      let days = 0;
      let minutes = 0;
      if (
        this.getContract &&
        this.getContract.startDate &&
        this.getContract.startDate.iso &&
        this.getContract.endDate &&
        this.getContract.endDate.iso
      ) {
        minutes =
          this.$moment(this.getContract.endDate.iso).diff(
            this.$moment(this.getContract.startDate.iso),
            "minutes"
          ) || 0;
        days = Math.ceil(minutes / (24 * 60));
      }
      return days;
    },
    dayMonthYearText() {
      let days = 0;
      let months = 0;
      let years = 0;
      let text = "";
      if (
        this.getContract &&
        this.getContract.startDate &&
        this.getContract.startDate.iso &&
        this.getContract.endDate &&
        this.getContract.endDate.iso
      ) {
        let a = this.$moment(this.getContract.endDate.iso).endOf("day");
        let b = this.$moment(this.getContract.startDate.iso).startOf("day");
        a.add(1, "days");
        years = a.diff(b, "year");
        b.add(years, "years");
        months = a.diff(b, "months");
        b.add(months, "months");
        days = a.diff(b, "days");
      }
      if (years) {
        text += `${years} ${this.$t('year')} `;
      }
      if (months) {
        text += `${months} ${this.$t('month')} `;
      }
      if (days) {
        text += `${days} ${this.$t('day')}`;
      }
      return text;
    },
    addAreaInterest() {
      this.tempInterest = null
      this.isInterestDialog = true
    },
    clickAreaInterest(areaInterest) {
      this.tempInterest = areaInterest
      this.isInterestDialog = true
    },
    async reloadAreaInterest() {
      this.isLoading = true
      try {
        await this.loadAreaInterest()
        this.$emit("reloadContract");
        this.$eventBus.$emit("updateAreaPlan");
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.$toast.show({
          content: error.message,
          color: "error"
        });
      }
    },
    onSuccessInterest(data) {
      this.loadContract(data.contract.objectId);
      this.$emit("reloadContract");
      this.$eventBus.$emit("updateAreaPlan");
      this.isInterestDialog = false;
      this.tabs = 'RentalContract';
    },
    viewAreaHistory() {
      const areaHistoryUrl = `/project/${this.projectId}/market/${this.marketId}/area-history/${this.areaObject.id}/view`
      window.open(areaHistoryUrl, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-box {
  display: grid;
  // padding: 5px;
  background: #fff;

  button {
    margin: 5px;
  }
}

.show-contract {
  // font-weight: 550;
  color: black;
  letter-spacing: 0.03rem;

  &.water {
    background-color: rgb(223, 238, 242);
  }

  &.elec {
    background-color: rgba(255, 129, 129, 0.3);
  }
}

.divider::after {
  @apply border-r bg-gray-300;
}

.booking-box {
  border: 1px solid rgba(128, 128, 128, 0.2);
  // border-radius: 5px;
  padding: 10px 15px;
  margin: 10px 0;
  align-items: center;

  .img-box {
    img {
      width: 60px;
      height: auto;
    }
  }

  .text-box {
    padding: 0 10px;
  }
}

.booking-box:hover {
  background: rgba(128, 128, 128, 0.05);
  cursor: pointer;
}

.money-sign {
  position: absolute;
  right: 0;
  top: -2px;
}

.money-sign.secondary {
  right: -20px;
  z-index: -1;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.tabs-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-right: 150px;
  background-color: white;
}

.area-history-container {
  align-content: center;
  background-color: white;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  .area-history-btn {
    font-weight: 400;
    font-size: 16px;
    bottom: 0;
    box-shadow: none !important;
    background-color: white;
  }
}

</style>

